import React, { useState } from "react";

export default function Career() {
  const [activeTab, setActiveTab] = useState("vendor");

  return (


<>







<section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Career </h1>
          </div>
        </div>
      </section>




    <div className="career-wrapper">

      {/* ===== LEFT SIDE INFO BOX ===== */}
      <div className="career-left">
        <img src="/images/9.jpg" alt="Pune Corporate Cars" className="career-logo" />
        <h3>Economical | Efficient | Dependable</h3>
        <p>Feel your journey with Pune Corporate Cars</p>
        <p>
          A Reliable Travel Partner for your Safety & Pleasant Journey.
        </p>
      </div>

      {/* ===== RIGHT SIDE FORM BOX ===== */}
      <div className="career-right">

        {/* === TAB BUTTONS === */}
        <div className="career-tabs">
          {/* <button
            className={activeTab === "vendor" ? "active" : ""}
            onClick={() => setActiveTab("vendor")}
          >
            Vendor Form
          </button> */}

          <button
            className={activeTab === "staff" ? "active" : ""}
            onClick={() => setActiveTab("staff")}
          >
            Staff Application
          </button>

          <button
            className={activeTab === "driver" ? "active" : ""}
            onClick={() => setActiveTab("driver")}
          >
            Driver Application
          </button>
        </div>

        {/* ================= VENDOR FORM ================= */}
        {activeTab === "vendor" && (
          <div className="form-section">
            <h3>Vendor Form</h3>

            <div className="form-row">
              <input type="text" placeholder="Full Name *" />
              <input type="text" placeholder="Enter Mobile Number *" />
            </div>

            <div className="form-row">
              <input type="email" placeholder="Enter Email *" />
              <input type="text" placeholder="Which Car You Have ? *" />
            </div>

            <textarea placeholder="Your Message"></textarea>

            <button className="send-btn">Send</button>
          </div>
        )}

        {/* ================= STAFF FORM ================= */}
        {activeTab === "staff" && (
          <div className="form-section">
            <h3>Staff Form</h3>

            <div className="form-row">
              <input type="text" placeholder="Full Name *" />
              <input type="text" placeholder="Enter Mobile Number *" />
            </div>

            <div className="form-row">
              <input type="email" placeholder="Enter Email *" />
              <input type="file" />
            </div>

            <textarea placeholder="Your Message"></textarea>

            <button className="send-btn">Send</button>
          </div>
        )}

        {/* ================= DRIVER FORM ================= */}
        {activeTab === "driver" && (
          <div className="form-section">
            <h3>Driver Form</h3>

            <div className="form-row">
              <input type="text" placeholder="Full Name *" />
              <input type="text" placeholder="Enter Mobile Number *" />
            </div>

            <div className="form-row">
              <input type="email" placeholder="Enter Email *" />
              <input type="text" placeholder="Which Vehicle You Can Drive? *" />
            </div>

            <div className="form-row">
              <input type="file" />
            </div>

            <textarea placeholder="Your Message"></textarea>

            <button className="send-btn">Send</button>
          </div>
        )}

      </div>
    </div>




</>
  );
}
